import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const formatTimeAgo = (date: Date | string, mobile: boolean = false): string => {
  const parsedDate = typeof date === 'string'
    ? dayjs.utc(date, 'YYYY-MM-DD HH:mm:ss').local()
    : dayjs(date);

  if (mobile) {
    const now = dayjs();
    const diffSecs = now.diff(parsedDate, 'second');
    const diffMins = now.diff(parsedDate, 'minute');
    const diffHours = now.diff(parsedDate, 'hour');
    const diffDays = now.diff(parsedDate, 'day');
    const diffWeeks = now.diff(parsedDate, 'week');
    const diffMonths = now.diff(parsedDate, 'month');

    if (diffSecs < 30) return 'now';
    if (diffSecs < 60) return '<1m';
    if (diffMins < 60) return `${diffMins}m`;
    if (diffHours < 24) return `${diffHours}h`;
    if (diffDays < 7) return `${diffDays}d`;
    if (diffDays < 30) return `${diffWeeks}w`;
    return `${diffMonths}mo`;
  }

  return parsedDate.fromNow()
    .replace(/^a (minute|hour|day|week|month|year)/, '1 $1');
};

/**
 * Formats duration in seconds to MM:SS format
 * @param seconds - Duration in seconds
 * @returns Formatted duration string (e.g., "3:45", "12:03")
 */
export const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};
